"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceApp = void 0;
var SourceApp;
(function (SourceApp) {
    SourceApp["HANDSHAKE"] = "handshake";
    SourceApp["NUCLEUS"] = "nucleus";
})(SourceApp || (exports.SourceApp = SourceApp = {}));
